module.exports = __webpack_public_path__ + "static/media/foodforfree.c237ef32.jpg";